import { c as _c } from "react/compiler-runtime";
import { SvgIcon } from '@mui/material';
export default function Icon(t0) {
  const $ = _c(4);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const props = t1;
  let t2;
  if ($[2] !== props) {
    t2 = <SvgIcon viewBox="0 0 40 40" {...props} />;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}